// 墙
import rlModel from "./rlModel";
import store from "@/store/index";
import { resetRlModules } from "@/mixins/LiteModuleDb.js";

class rlWallHole extends rlModel {
  constructor() {
    super();
    this.componentType = "wallHole";
    this.points = []; // 顶点数据

    this.m_gridData = {}; //关联的网格数据
    // this.m_sectParamData = {}; //墙截面数据
    // this.SectData = []; //墙截面组合数据

    this.m_wallThick = 0; //墙洞所在墙的墙厚
    this.m_wallEcc = 0; //墙洞所在墙的偏轴

    this.Ecc = null; //洞口定位距离
    this.HDiff = null; //洞口底部标高

    this.classTypeName = "rlWallHole"; // 墙

    this._threeObj = null; ////三维图形对象

    this.Color = "#fff";
    this.ModelType = "墙洞";
    // this.defaultColor = "#ffff00"; //默认颜色
    // this.Color =
    //   (this.rlLayer && this.rlLayer[2] && this.rlLayer[2].storey) || "#ffff00"; //构件颜色
    // this.Layer = "rlWallSeg"; //图层名称
    // this.LinkGuids = null; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlWallHoleGroup"; //组名

    // wasm接口方法
    this.getPKPM_WallHoleData =
      store.state.globalData.rl_wasm_module.getPKPM_WallHoleData;
  }

  // 自定义对象在绘制时会重新创建
  create() {
    return new this.constructor();
  }

  initData(obj) {
    super.initData(obj);

    this.m_gridData = obj.m_gridData;
    this.m_wallThick = obj.m_wallThick; //墙洞所在墙的墙厚
    this.m_wallEcc = obj.m_wallEcc; //墙洞所在墙的偏轴
    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc; //洞口定位距离
    this.HDiff = obj.HDiff; //洞口底部标高

    this.Color = obj.Color ? obj.Color : "#fff";
  }

  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData = rlAppObj.rlMxDrawObject.getMxEntity(obj.m_gridData);
    this.m_wallThick = obj.m_wallThick; //墙洞所在墙的墙厚
    this.m_wallEcc = obj.m_wallEcc; //墙洞所在墙的偏轴
    // const wallSect = obj.wallSect;
    this.Ecc = obj.Ecc; //洞口定位距离
    this.HDiff = obj.HDiff; //洞口底部标高
  }

  // 数据转换
  convert() {
    let res = this.getPKPM_WallHoleData(
      this.m_gridData.m_stJoint.m_pt[0],
      this.m_gridData.m_stJoint.m_pt[1],
      this.m_gridData.m_edJoint.m_pt[0],
      this.m_gridData.m_edJoint.m_pt[1],
      Number(this.m_sectParamData.B),
      Number(this.m_sectParamData.H),
      Number(this.m_wallThick),
      Number(this.m_wallEcc),
      Number(this.Ecc),
      Number(this.HDiff),
      Number(this.LevelB)
    );

    this.getModelDrawData(JSON.parse(res));

    // this.m_sectGroupName = this.m_sectParamData.B.toString();
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    this.points = modelData.Points;
    this.index3dData = modelData["3D"]["3dFaces"]
      .map((item) => item.index)
      .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
  }

  // 克隆
  async myClone() {
    let newObj = await super.myClone();

    newObj.m_gridData = this.m_gridData;
    newObj.Ecc = this.Ecc;
    newObj.HDiff1 = this.HDiff1;
    newObj.HDiff2 = this.HDiff2;
    newObj.HDiffB = this.HDiffB;

    newObj.points = this.points;
    return newObj;
  }

  // 绘制
  worldDraw(pWorldDraw) {
    this.convert();
    if (pWorldDraw.mxObj._is2d) {
      pWorldDraw.setColor(new THREE.Color(this.Color));
      this.create2dModel(this.index2dData, pWorldDraw);
    }

    this._threeObj = this.create3dModel(
      this.points, // 顶点数据
      this.index3dData, // 三维索引数据
      0.001, // 缩小比例(解决闪烁问题)
      500, // 渲染顺序
      true
    );

    this.m_gridData.m_wallHoleId = this.objectId();
    // pWorldDraw.drawEntity(wObj);
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    this.onDwgIn(obj);
    return true;
  }

  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData) data["GridGuid"] = this.m_gridData.Guid;

    data["Ecc"] = this.Ecc;
    data["HDiff"] = this.HDiff;
    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData"] = this.m_gridData.objectId();
    data["Ecc"] = this.Ecc;
    data["HDiff"] = this.HDiff;
    data["m_wallThick"] = this.m_wallThick; //墙洞所在墙的墙厚
    data["m_wallEcc"] = this.m_wallEcc; //墙洞所在墙的偏轴

    return data;
  }

  // 删除
  erase() {
    this.m_gridData ? (this.m_gridData.m_wallId = null) : "";
    super.erase();
  }

  // // 偏移
  // transformBy () {
  //   // 定义平移的偏移量
  //   const offsetX = 10000
  //   const offsetY = 0
  //   const offsetZ = 0
  //   // 对每个坐标进行平移操作
  //   for (let i = 0; i < this.index2dData.length; i += 3) {
  //     this.index2dData[i] += offsetX // 平移 x 坐标
  //     this.index2dData[i + 1] += offsetY // 平移 y 坐标
  //     this.index2dData[i + 2] += offsetZ // 平移 z 坐标
  //   }
  //   // 对每个坐标进行平移操作
  //   for (let i = 0; i < this.points.length; i += 3) {
  //     this.points[i] += offsetX // 平移 x 坐标
  //     this.points[i + 1] += offsetY // 平移 y 坐标
  //     this.points[i + 2] += offsetZ // 平移 z 坐标
  //   }
  // }
}

export { rlWallHole };
